<template>
    <div class="m-profile">
        <div class="title_wrap">
            <p class="page_title">{{ $t('my.personalInfo') }}</p>
        </div>

        <div class="aside">{{ $t('my.personTip') }}</div>

        <el-form
            ref="Form"
            :model="userInfo"
            class="m_form"
            auto-complete="on"
            label-position="left"
            label-width="100px"
        >

            <el-form-item :label="$t('my.avatar')">
                <el-input
                    v-model="userInfo.avatar_id"
                    type="hidden"
                />
                <pan-thumb :image="userInfo.avatar_url" />
                <el-button
                    type="primary"
                    icon="upload"
                    style="position: absolute;bottom: 15px;margin-left: 40px;"
                    @click="imagecropperShow=true"
                >{{ $t('my.uploadAvatar') }}</el-button>

                <image-cropper
                    v-show="imagecropperShow"
                    :key="imagecropperKey"
                    :width="100"
                    :height="100"
                    :url="upload_url"
                    field="iFile"
                    lang-type="zh"
                    @close="imagecropperShow = false"
                    @crop-upload-success="cropSuccess"
                />
            </el-form-item>

            <el-form-item
                prop="nick_name"
                :label="$t('my.realName')"
            >
                <el-input
                    v-model="userInfo.nick_name"
                    name="nick_name"
                    type="text"
                    auto-complete="on"
                    :placeholder="$t('my.realNamePlac')"
                    class="m_form_item_input"
                    clearable
                />
            </el-form-item>

            <el-form-item
                prop="mobile"
                :label="$t('my.mobile')"
            >
                <el-input
                    v-model="userInfo.mobile"
                    name="mobile"
                    type="text"
                    auto-complete="on"
                    :placeholder="$t('my.mobile')"
                    class="m_form_item_input"
                    clearablej
                    disabled
                />
            </el-form-item>

            <el-form-item
                prop="gender"
                :label="$t('my.sex')"
            >
                <primarySelect
                    v-model="userInfo.gender"
                    :data="sexList"
                    :placeholder="$t('my.sexPlac')"
                    clearable
                    class="m_form_item_input"
                />
            </el-form-item>

            <el-form-item>
                <el-button
                    v-waves
                    class="form_submit"
                    :loading="saveLoading"
                    size="medium"
                    type="primary"
                    @click.native.prevent="submit"
                >{{ $t('my.editPersonal') }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import waves from '@/directive/waves'
import primarySelect from '@/components/primarySelect'
import ImageCropper from '@/components/ImageCropper'
import PanThumb from '@/components/PanThumb'
import mix_user from '@/views/login/mix_user'
import { saveProfile } from '@/api/Auth'

export default {
    name: 'Profile',
    directives: { waves },
    components: { primarySelect, ImageCropper, PanThumb },
    mixins: [mix_user],
    data() {
        return {
            saveLoading: false,
            imagecropperShow: false,
            imagecropperKey: 0,
            upload_url: process.env.VUE_APP_BASE_API + 'basic/image',
            userInfo: {
                id: undefined,
                avatar_id: '',
                avatar_url: '',
                gender: 0,
                gender_name: '',
                mobile: '',
                realname: '',
                status: '1',
                created_at: ''
            },
            sexList: [{ key: '0', value: '未知' }, { key: '1', value: '男' }, { key: '2', value: '女' }]
        }
    },

    created() {
        this.userInfo = this.$store.getters.userInfo
        console.log('userInfo', this.userInfo)
    },

    methods: {
        toPage(url) {
            this.$route.path !== url ? this.$router.push({ path: url, query: { tid: this.tid } }) : ''
        },

        cropSuccess(resData) {
            this.imagecropperShow = false
            this.imagecropperKey = this.imagecropperKey + 1
            this.userInfo.avatar_id = resData.id
            this.userInfo.avatar_url = resData.file_path
        },

        submit() {
            console.log('this.userInfo', this.userInfo)
            this.saveLoading = true
            saveProfile(this.userInfo).then(res => {
                if (res.code === 200) {
                    this.$notify({
                        title: this.$t('Notification.suc_title'),
                        message: this.$t('Notification.suc_edit_msg'),
                        type: 'success',
                        duration: 2000
                    })
                    this.saveLoading = false
                }
            }).catch(() => { this.saveLoading = false })
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.m-profile {
    .title_wrap {
        height: 100px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .page_title {
            line-height: 100px;
            font-weight: 400;
            font-size: 24px;
            color: #333;
        }

        .btn_group {
            .primary_btn {
                height: 33px;
            }
        }
    }

    .aside {
        margin: 20px 30px 40px;
        padding: 18px 40px;
        background: #fdf6ec;
        border-radius: 10px;
        line-height: 24px;
        text-align: left;
        font-size: 14px;
        color: #000;
    }

    .m_form {
        width: 550px;
        margin: 0 auto;
        box-sizing: border-box;

        .el-form-item__label {
            text-align: right;
            line-height: 48px;
            font-size: 16px;
            color: #000000;
        }

        .m_form_item_input {
            margin-left: 10px;

            .el-input__inner {
                width: 450px;
                height: 48px;
                border-color: #f2f2f2;
                background: #f2f2f2;
                border-radius: 24px;
            }
        }

        .form_submit {
            margin-top: 40px;
            width: 160px;
            height: 48px;
            line-height: 48px;
            padding: 0 20px;
            box-shadow: 2px 3px 10px 0px rgba(146, 109, 61, 0.29);
            border-radius: 24px;
            font-size: 16px;
            color: #f3f5f4;
        }
    }
}
</style>
